module.exports = __webpack_public_path__ + "img/app_icon_18.b8b5035d.png";